import apiFactory from '../apiFatory';

export default apiFactory(
  'App',
  [
    'ajaxProcess',
    'ajaxProcessECA',
    'getCustomerInfoCache',
    'getCode',
    'verifyCode',
    'upload',
    'getAppConfig',
    'setMeasurementSystem',
    'isSamrtGfs',
    'ajaxLandrayProcess',
    'ufileTaskCreate',
    'getMenu',
    'ajaxWebsiteAdminWhite',
    'getHelpGuideConfig',
    'fmsUpload',
    'fmsUploadNew',
    'getTableSettings',
    'addHideList',
    'ajaxSend',
    'ajaxSave',
    'getWarehouseListDetail',
    'getIMSserviceQueryServiceType',
    'getOptionByServiceCode',
    'getInventoryTypeAdjustmentMmsConfig',//新增分类库存调整单、全部分类库存调整单菜单是否显示
    'getUnLoginAppConfig', // 非登录页面配置信息
    'setLang',//设置多语言
    'ajaxProcessWithoutAuth',// ajax请求，不鉴权
    'setIsOpenExceptionNofify',// 设置是否开启异常通知
    'ajaxProcessHelpAPI',//临时，到标准索赔服务端迁移完
    'getIsAmazonFBAReturnOrder',// amazon退货单是否启用
    'ajaxFmsCloudLink', // 获取 fms 云链接
    'ajaxProcessEdsAPI',// 异步请求eds API

  ]
);
